var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldable',{attrs:{"label":_vm.label,"name":_vm.name,"no":_vm.independent}},[_c('el-cascader',{attrs:{"value":_vm.valueAsKey,"options":_vm.options,"props":_vm.config,"disabled":_vm.disabled,"show-all-levels":false,"clearable":"","filterable":""},on:{"change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }